// extracted by mini-css-extract-plugin
export var arrow = "-tb5yLti";
export var arrowSvg = "+91TMd6v";